import styled from 'styled-components'

export const StyledList = styled.ul`
margin-left: 1rem
`
